// extracted by mini-css-extract-plugin
export default {"TipContainer":"vvCMna8_zpnfZNhgNvhX","TipTitle":"Pv_aDNze37yj67dqxp0J","TipContent":"KYp2DylcOdh688QIO20Q","Tip":"lAgjIsW4OYOi3sRjFVf0"};